<template>
  <div>
    <SummaryRow
      :ratings="ratings"
      :globalRating="ssrReviewData.globalAverage"
      @setViewDetailClicked="handleSetViewDetailClicked"
    />

    <BorderHorizontal v-if="screenType !== 'mobile'" :my="'my-1'" />

    <RatingsTotals
      v-if="viewDetailClicked"
      @setRatingsToShow="handleSetRatingsToShow"
    />

    <Slider
      :reviewsArray="reviewsArray"
      @openAllReviews="state.seeAllPopupOpen = true"
    />

    <PopupBase
      :open="state.seeAllPopupOpen"
      @closePopup="state.seeAllPopupOpen = false"
      :styleTop="'50px'"
    >
      <AllReviews @closePopup="state.seeAllPopupOpen = false" />
    </PopupBase>

    <div
      class="d-none d-lg-flex w-100 my-3 cursor-pointer text-light-blue justify-content-end"
    >
      <span @click.stop="state.seeAllPopupOpen = true" class="link-default">
        {{ content.liheReviews_seeReviews }}
        {{ ssrReviewData.reviewsSize }}
        {{ content.liheReviews_reviews }}
        <svg width="10" height="10" class="icon text-primary-blue">
          <use href="#___icon___chevron-right"></use>
        </svg>
      </span>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, watch } from 'vue'
import { useStore } from 'vuex'

// Components
import RatingsTotals from '@/vue/reviews-translation/components/reviews/ratingsTotals.vue'
import SummaryRow from '@/vue/reviews-translation/components/reviews/summaryRow.vue'
import Slider from '@/vue/reviews-translation/components/reviews/slider.vue'
import PopupBase from '@/vue/common/popupBase.vue'
import AllReviews from '@/vue/reviews-translation/components/popups/allReviews/allReviews.vue'
import BorderHorizontal from '@/vue/common/borderHorizontal.vue'

// Config
import ratingOrder from '@/config/ratingOrder'

// Store
const store = useStore()

const content = computed(() => store.state.content)
const ssrReviewData = computed(() => store.state.ssrReviewData)
const reviewsArray = computed(() => store.state.reviewsArray)
const ratingsToShow = computed(() => store.state.ratingsToShow)
const viewDetailClicked = computed(() => store.state.viewDetailClicked)
const screenType = computed(() => store.state.screenType)
const language = computed(() => store.state.language)

// Local reactive state
const state = reactive({
  seeAllPopupOpen: false,
})

console.log('in reviews translation app', {
  content: content.value,
  ssrReviewData: ssrReviewData.value,
  reviewsArray: reviewsArray.value,
  ratingsToShow: ratingsToShow.value,
  viewDetailClicked: viewDetailClicked.value,
  screenType: screenType.value,})

// Ratings array
const ratings = computed(() =>
  ratingOrder
    .map((ratingName) => ({
      name: ratingName,
      rating: ssrReviewData.value[ratingName],
    }))
    .filter(Boolean)
)

// Methods
function handleSetViewDetailClicked() {
  store.commit('setViewDetailClicked', !viewDetailClicked.value)
  if (!viewDetailClicked.value) {
    store.commit('setRatingsToShow', null)
  }
}

function handleSetRatingsToShow(e) {
  store.commit('setRatingsToShow', e)
}

</script>

<style scoped>

</style>
